import { useTheme } from '@mui/material';
import { InfoOutlined, NotInterested, ThumbUpAlt } from '@mui/icons-material';
import { EmptyStateType } from './EmptyState';

type EmptyStateColours = {
  IconComponent: React.ElementType | null;
  iconBgColor: string;
  iconColor: string;
  textColor: string;
  containerBgColor: string;
};

export const useEmptyStateColours = (
  type: EmptyStateType
): EmptyStateColours => {
  const theme = useTheme();

  switch (type) {
    case 'no-results':
      return {
        IconComponent: InfoOutlined,
        iconBgColor: theme.palette.warningV2.main,
        iconColor: theme.palette.warningV2.dark,
        textColor: theme.palette.warningV2.dark,
        containerBgColor: theme.palette.warningV2.light
      };
    case 'no-records':
      return {
        IconComponent: NotInterested,
        iconBgColor: theme.palette.customGrey.light,
        iconColor: theme.palette.primary.main,
        textColor: theme.palette.customGrey.dark,
        containerBgColor: theme.palette.customGrey.light
      };
    case 'complete':
      return {
        IconComponent: ThumbUpAlt,
        iconBgColor: theme.palette.successV2.main,
        iconColor: theme.palette.white,
        textColor: theme.palette.customGrey.dark,
        containerBgColor: theme.palette.successV2.light
      };
    case 'loading':
      return {
        IconComponent: null,
        iconBgColor: 'transparent',
        iconColor: theme.palette.primary.main,
        textColor: theme.palette.primary.main,
        containerBgColor: theme.palette.background.default
      };
  }
};
